import { Component } from '@angular/core';
import {CardComponent} from '../../../../shared/components/card/card.component';

@Component({
  selector: 'app-page-terms',
    imports: [
        CardComponent
    ],
  templateUrl: './page-terms.component.html',
  styleUrl: './page-terms.component.scss'
})
export class PageTermsComponent {

}
